
import React, { useState, forwardRef, useRef } from 'react';
import {
    DialogContent, DialogTitle, Dialog, Paper, TextField, Box, Grid, Typography, TableCell, TableContainer,
    Table, TableHead, Button, IconButton, TableRow, TableBody, Accordion, AccordionDetails,
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
// import PurchaseEntryPrint from './PurchaseEntryPrint';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { StyledTableCell, StyledTableRow } from '../../reusableComponent/StyledTable';
import PurchaseInvoiceAdd from './PurchaseInvoiceAdd';
import styles from '.././../../styles.module.css';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PurchaseInvoicePrint from './PurchaseInvoicePrint';
import RemarksSection from '../../reusableComponent/RemarksSection';

const ComponentToPrintRow = forwardRef((props, ref) => {
    const { value } = props;
    return (
        <div className="print-source" ref={ref}>
            <PurchaseInvoicePrint orderPrint={value} />
        </div>
    );
});

const ComponentToPrintInvoiceWrapper = ({ orderPrint }) => {
    const ref = useRef();

    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <Icon icon="flat-color-icons:print" width="20" height="20" />}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}>
                <ComponentToPrintRow ref={ref} value={orderPrint} />
            </div>
        </div>
    );
};

const PurchaseInvoiceDetails = (props) => {
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const navigate = useNavigate()

    const detailsView = props.details;
    const [open, setOpen] = useState(false)
    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleClickOpenPopup = (info) => {
        // setInfo(info);
        setOpen(true);
    };

    const navigateToAddEdit = (row) => {
        const state = {
            row,
            // invoiceSettingList,
        };
        navigate('/purchase/add-purchase-invoice', { state });
    };
    const navigateToPayment = (row) => {
        const state = {
            row,
        };
        navigate('/sales/customer-payment', { state });
    };
    return (
        <>
            <Paper className='mainContainer' sx={{ boxShadow: 'none' }}>
                <Box>
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item md={10}>
                            <Grid container spacing={1} sx={{ mt: 0 }}>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Supplier Name</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`} >{detailsView.supplierName == null ? '-' : detailsView.CNS_Name}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Inward No</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.inwardNo}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Inward Date</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{dateConversion(detailsView.inwardDate)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Invoice No</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.invoiceNo)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Invoice Date </Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{dateConversion(detailsView.invoiceDate)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Order No</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {detailsView.orderNo == '' ? '-' : detailsView.orderNo}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Order Date</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.orderNo == '' ? '-' : dateConversion(detailsView.orderDate)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Transporter</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {detailsView.transporter == '' ? '-' : detailsView.transporter}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`}>Vehicle No</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {detailsView.vehicleNo == '' ? '-' : detailsView.vehicleNo}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={2}>
                            <Box >
                                <Grid container spacing={0} >
                                    <Grid item md={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                        <Box sx={{ marginBottom: '6px' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'right', }}>
                                                <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }} onClick={() => navigateToAddEdit(detailsView)} />
                                            </Box>
                                            < Box >
                                                <Icon icon="clarity:email-line" width="19" height="19" color="red" style={{}} className={`${styles.underline}`} />
                                            </Box>
                                            < Box>
                                                <ComponentToPrintInvoiceWrapper className={`${styles.underline}`} key={detailsView._id} orderPrint={detailsView} />
                                            </Box>
                                            < Box >
                                                <PaymentsOutlinedIcon className={`${styles.underline}`} onClick={() => navigateToPayment()} />
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 140 }}>
                    <Table sx={{ minWidth: 700 }} size='small' stickyHeader>
                        <TableHead >
                            <StyledTableRow>
                                <StyledTableCell align="left" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>
                                    Item Description
                                </StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>HSN Code</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Quantity</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Unit</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Rate</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>GST %</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Amount</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {JSON.parse(detailsView && detailsView.childRows).map((row, index) => (
                                <>
                                    <StyledTableRow key={row.id} >
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>  {row.itemName + ' (' + row.itemCode + ')'}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.hsnCode}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.quantity}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.unit}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.rate}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.gst} %</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{parseFloat(row.amount).toFixed(2)}</StyledTableCell>
                                    </StyledTableRow>
                                </>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box style={{ padding: '2px' }}>
                    <Grid container spacing={0} sx={{ mt: 2 }}>
                        <Grid item xs={8}>
                            {/* {(detailsView.remark == '' || detailsView.remark == null || detailsView.remark == undefined) ?
                                <></>
                                :
                                < Typography className={`${styles.detail_lable}`} > <span style={{ fontWeight: 'bold', paddingTop: '10px' }}>Remarks: </span> {detailsView.remark}</Typography>
                            } */}
                            <RemarksSection remark={detailsView.remark} />
                        </Grid>
                        <Grid item xs={4} >
                            <Grid container spacing={0} sx={{ mt: 0, }} >
                                <Grid item xs={8} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}>Basic Total </Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', }}>
                                    <Typography className={`${styles.erp_lable}`}>{parseFloat(detailsView.basicTotal).toFixed(2)}</Typography>
                                </Grid>
                                <Grid item xs={8} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}>GST Total </Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}> {parseFloat(detailsView.gstTotal).toFixed(2)}</Typography>
                                </Grid>
                                <Grid item xs={8} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}>CGST Total </Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}>{parseFloat(detailsView.cgstTotal).toFixed(2)}</Typography>
                                </Grid>
                                <Grid item xs={8} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}>SGST Total </Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', }}>
                                    <Typography className={`${styles.erp_lable}`}>{parseFloat(detailsView.sgstTotal).toFixed(2)}</Typography>
                                </Grid>
                                <Grid item xs={8} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}>IGST Total </Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', }}>
                                    <Typography className={`${styles.erp_lable}`}>{parseFloat(detailsView.igstTotal).toFixed(2)}</Typography>
                                </Grid>
                                <Grid item xs={8} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}> Total</Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', }}>
                                    <Typography className={`${styles.erp_lable}`}>{parseFloat(detailsView.total).toFixed(2)}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
            <BootstrapDialog
                PaperProps={{
                    sx: {
                        maxWidth: "85%",
                        height: "95%"
                    }
                }}
                onClose={handleClose}
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    Update Purchase Invoice
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <PurchaseInvoiceAdd handleCloseDialog={handleClose} details={detailsView} />
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}
export default PurchaseInvoiceDetails;